import { Link } from "react-router-dom";
import { DocumentData, UpdateWill } from "../../api/get";
import { useEffect, useState } from "react";
import Loader from "../../loader";
import Header from "../../Common/Header";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { handleApiError } from "../../Common/Helper";
const Document = () => {
  const [documentData, setDocumentData] = useState([]);
  const [contentLoader, setContentLoader] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    DocumentData()
      .then((res) => {
        if (res.success && res.status_code === "200") {
          setDocumentData(res.data);
          setContentLoader(false);
        } else {
          handleApiError(res, navigate); // Use helper function
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const UpdateWillFunction = () => {
    UpdateWill()
      .then((res) => {
        console.log(res);
        if (res.success && res.status_code === "200") {
          // toast.success("Your Will Updated Successfully");
          setTimeout(() => {
            navigate("/dashboard");
          }, [1500]);
        } else {
          handleApiError(res, navigate); // Use helper function
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <>
      {contentLoader ? (
        <Loader />
      ) : (
        <>
          <Header />
          <div>
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
              <div className="my-3">
                <h4 className="text-[24px] sm:text-[28px] lg:text-[34px] font-bold">
                  Your documents
                </h4>
                <p className="text-[14px] sm:text-[18px] lg:text-[20px] font-bold text-slate-500 mt-2">
                  Here you can see your documents as well as whether you’ve
                  written and completed them successfully.
                </p>
              </div>
              <div className="py-8 ">
                <div className="flex flex-col md:flex-row items-center md:justify-between bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
                  <div className="mb-4 md:mb-0 md:w-1/5 flex-shrink-0">
                    <img
                      className="w-full h-full object-contain"
                      src="/assets/images/document-header.png"
                      alt="Document Header"
                    />
                  </div>
                  <div className="md:w-2/5 text-center md:text-left">
                    <h4 className="text-[18px] sm:text-[22px] md:text-[26px] font-bold">
                      {documentData.will_label}
                    </h4>
                    <p className="text-[12px] sm:text-[14px] md:text-[18px] font-bold text-slate-500 mt-2 mb-4">
                      {documentData.will_desc}
                    </p>
                  </div>
                  <div className=" ">
                    {documentData.will_status != "Completed" && (
                      <Link to={"/dashboard"}>
                        <button className="text-sm sm:text-base px-4 py-2 border border-black rounded bg-white hover:bg-gray-100 transition hover:bg-primary hover:text-white">
                          {documentData.will_status ? "Continue" : "Start"}
                        </button>
                      </Link>
                    )}
                    {documentData.will_status === "Completed" && (
                      <button
                        className="text-sm sm:text-base px-4 py-2 border border-black rounded bg-white hover:bg-gray-100 transition hover:bg-primary hover:text-white font-bold"
                        onClick={() => UpdateWillFunction()}
                      >
                        Update Will
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <div className="border-dashed border-b-2 mb-5"></div>
              <div className="px-4 sm:px-6 pt-6 hidden lg:block">
                <div className="grid grid-cols-4 text-center sm:text-left">
                  <p className="uppercase text-[12px] sm:text-[14px] lg:text-[18px] text-slate-500">
                    Name
                  </p>
                  <p className="uppercase text-[12px] sm:text-[14px] lg:text-[18px] text-slate-500">
                    {/* Empty placeholder */}
                  </p>
                  <p className="uppercase text-[12px] sm:text-[14px] lg:text-[18px] text-slate-500">
                    Status
                  </p>
                  <p className="uppercase text-[12px] sm:text-[14px] lg:text-[18px] text-slate-500 lg:text-right">
                    Action
                  </p>
                </div>
              </div>
              <div className="pb-6">
                <div className="flex flex-col lg:flex-row items-center lg:justify-between bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
                  <div className="lg:w-2/5 text-center lg:text-left">
                    <h4 className="text-[20px] sm:text-[26px] lg:text-[25px] font-bold">
                      Your Will{" "}
                      {documentData.issue === "true" && (
                        <span className="text-red-500 text-[16px]">
                          {" "}
                          ISSUES
                        </span>
                      )}
                    </h4>
                    <p className="text-[12px] sm:text-[14px] lg:text-[18px] font-bold text-slate-500 mt-2 mb-2">
                      Leave your estate to the people you love
                    </p>
                  </div>
                  <div className="lg:w-1/5 text-center lg:text-left">
                    <p className="text-[14px] sm:text-[16px] lg:text-[20px] font-bold text-slate-500 mb-2">
                      {documentData.will_status
                        ? documentData.will_status
                        : "Incomplete"}
                    </p>
                  </div>
                  <div className="lg:w-1/5 text-center lg:text-right">
                    <Link
                      to={
                        documentData.issue === "true"
                          ? "/make-will-online/execution/errors"
                          : "/dashboard"
                      }
                    >
                      <button className="font-bold text-sm sm:text-base px-4 py-2 bg-primary text-white rounded hover:bg-primary-dark transition">
                        {documentData.issue === "true"
                          ? "Edit"
                          : documentData.will_status
                          ? "Continue"
                          : "Start"}{" "}
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Document;
